import {EvalueringModel} from "./evalueringModel";

export class ForloebEvalueringModel {
    public static FromResponseModel(forloebEvalueringId: string, indsendt: boolean, evaluering: EvalueringModel): ForloebEvalueringModel{
        let model = new ForloebEvalueringModel();

        model.forloebEvalueringId = forloebEvalueringId;
        model.indsendt = indsendt;
        model.evaluering = evaluering;

        return model;
    }

    forloebEvalueringId: string;
    indsendt: boolean;
    evaluering: EvalueringModel;
}

